import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';

import { FirebaseService } from './shared/services/firebase.service';
import { StorageService } from './shared/services/storage.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly firebaseService: FirebaseService,
    private readonly messageService: MessageService,
    private readonly storage: StorageService
  ) {}

  ngOnInit(): void {
    this.initializeFirebaseNotifications();

    if (this.storage.getToken()) {
      this.listenToBackgroundMessages();
    }
  }

  private initializeFirebaseNotifications(): void {
    this.firebaseService.requestPermissionAndGetToken().then(() => {
    });

    this.firebaseService.listenToForegroundMessages((payload) => {
      const title = payload?.notification?.title ?? 'Notifica';
      const body = payload?.notification?.body ?? '';

      this.showNotification(title, body);
    });
  }

  private listenToBackgroundMessages(): void {
    this.firebaseService.listenToMessages((payload) => {
      const title = payload.notification?.title ?? 'Notifica';
      const body = payload.notification?.body ?? '';

      this.showNotification(title, body, 5000);
    });
  }

  private showNotification(summary: string, detail: string, life?: number): void {
    this.messageService.add({
      severity: 'info',
      summary,
      detail,
      life,
    });
  }
}